export default {
  list: '/v3/supplier/supportCar/list'
}
